// Reittilinjat karttatasona: mitkä reitit piirretään kartalle.
// Taso on oma valintansa (Kartta → Tasot → "Reitit"); oletuksena se on päällä, ja vain
// nimenomainen false piilottaa sen, jotta vanha tallennettu asetus (ilman tätä avainta) ei piilota reittejä.
// Kohteet-listasta valittu reitti (selectedId) näytetään aina, vaikka taso olisi piilotettu: käyttäjä pyysi sen näkyviin.

import { routeLines, routeVertices } from "./routeGeometry.js";

const hasLine = (r) => routeLines(r.geometry).length > 0;

/** Piirrettävät reitit: ne, joilla on linja, ja vain jos taso on päällä (valittu reitti aina). */
export function visibleRoutes(content, overlays, selectedId = null) {
  const routes = (content?.routes ?? []).filter(hasLine);
  return overlays?.routes === false ? routes.filter((r) => r.id === selectedId) : routes;
}

/** Linjan rajat Leafletin muodossa [[etelä, länsi], [pohjoinen, itä]]; null, jos linjaa ei ole. */
export function lineBounds(geometry) {
  const vertices = routeVertices(geometry);
  if (!vertices.length) return null;
  const lats = vertices.map((p) => p[0]);
  const lons = vertices.map((p) => p[1]);
  return [
    [Math.min(...lats), Math.min(...lons)],
    [Math.max(...lats), Math.max(...lons)],
  ];
}

